import { formatNumberToPrice, parseNumber } from '.';

export const formatStringToPrice = (value: string) => {
   const parsedNumber = parseNumber(value);
   const price = formatNumberToPrice(parsedNumber);
   return price;
};
